import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ConnectGuardProps {
  children: React.ReactElement;
}

const ConnectGuard: React.FC<ConnectGuardProps> = ({ children }) => {
  const { isSuperAdmin, isConnectClient, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isSuperAdmin && !isConnectClient) {
    return <Navigate to="/subscription-required" replace />;
  }

  return children;
};

export default ConnectGuard;
